import coreAPIInstance from "./coreApiInstance";

export const transformVideosAPIs = {
  getTransformVideos: ({ payload, streamId, entityId }) =>
    coreAPIInstance.get(`/api/transformed-clips/${streamId}/${entityId}`, payload),
};
